module.exports = {"130205001":"马家沟街道","130205002":"开平街道","130205003":"税务庄街道","130205005":"陡电街道","130205006":"荆各庄街道","130205100":"开平镇","130205101":"栗园镇","130205102":"郑庄子镇","130205103":"双桥镇","130205104":"洼里镇","130205105":"越河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130205.json
// module id = 84
// module chunks = 0